module.exports = __webpack_public_path__ + "img/vehicle.8607616b.svg";